'use strict';
import React, { Component } from 'react';

class PantallaPrincipalMaxwell extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Maxwell__logo">
            </div>
        );
    }
}

export default PantallaPrincipalMaxwell;
